export type SystemStateContext = 'development' | 'deployment';

export interface SystemStateInfo {
  text: string;
  colorClass: string;
}

const unknownSystemStateInfo: SystemStateInfo = {
  text: 'Estado desconocido',
  colorClass: 'bg-neutral-dark',
};

export function mapSystemStateInfo(state: string | null | undefined, context: SystemStateContext): SystemStateInfo {
  switch (state?.toUpperCase()) {
    case 'CORRECTION':
      return {
        text: context === 'development' ? 'Desarrollo en subsanación' : 'Despliegue en subsanación',
        colorClass: 'bg-alert-base',
      };
    case 'APPROVED':
      return {
        text: context === 'development' ? 'En desarrollo' : 'Despliegue revisado',
        colorClass: context === 'development' ? 'bg-warning-base' : 'bg-success-base',
      };
    case 'PENDING':
      return {
        text: context === 'development' ? 'Desarrollo solicitado' : 'Despliegue solicitado',
        colorClass: 'bg-info-base',
      };
    default:
      return unknownSystemStateInfo;
  }
}
